<script lang="ts">
  import type { ReviewBlockStoryblok } from '$types/bloks';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import Icon from '$components/ui/icon/icon.svelte';
  import CmsImage from '$components/cms-image.svelte';
  import { cn } from '$lib/utils';
  import { format } from 'date-fns';
  import Divider from '$components/ui/divider.svelte';
  import { t } from '$lib/i18n';

  export let review: ReviewBlockStoryblok | undefined;
  let className: string | undefined = undefined;
  export { className as class };
  $: hasCustomFields = review?.recommend || review?.delivered_in_time || review?.product_fit;
</script>

{#if review}
  <div class={cn('bg-highlight p-3 rounded-md mb-3', className)} use:storyblokEditable={review}>
    <div class="flex items-center justify-between">
      {#if review.stars}
        {@const stars = review.stars ? parseInt(review.stars) : 5}
        <div>
          {#each Array(stars) as _}
            <Icon size="sm" icon="star-filled" class="text-gold" />
          {/each}

          {#if stars < 5}
            {#each Array(5 - stars) as _}
              <Icon size="sm" icon="star-filled" class="text-gold/20" />
            {/each}
          {/if}
        </div>
      {/if}
      <p class="text-sm text-primary/80">
        {review.date ? format(new Date(review.date), 'MMM dd, yyyy') : review.name}
      </p>
    </div>
    {#if review.photo}
      <CmsImage
        image={review.photo}
        alt={review.photo.alt}
        class="aspect-[83/70] mt-3 w-full md:max-h-[300px] lg:max-h-[280px] object-cover rounded-sm"
      />
    {/if}
    <div class="mt-3">
      <p class="text-md font-semibold">{review.title}</p>
      <p class="mt-1 text-md">{review.text}</p>
    </div>

    {#if hasCustomFields}
      <Divider class="mt-3" />

      <div class="flex flex-col gap-2.5 pt-2.5">
        {#if review.recommend}
          <div class="flex items-center justify-between text-sm/tight text-primary/60">
            <p>{$t('reviews.recommend')}</p>
            <p class="text-right">{review.recommend}</p>
          </div>
        {/if}
        {#if review.product_fit}
          <div class="flex items-center justify-between text-sm/tight text-primary/60">
            <p>{$t('reviews.fitting')}</p>
            <p class="text-right">{review.product_fit}</p>
          </div>
        {/if}
        {#if review.delivered_in_time}
          <div class="flex items-center justify-between text-sm/tight text-primary/60">
            <p>{$t('reviews.delivery')}</p>
            <p class="text-right">
              {review.delivered_in_time ? $t('reviews.on_time') : $t('reviews.late')}
            </p>
          </div>
        {/if}
      </div>
    {/if}

    {#if review.verified_buyer}
      <Divider class="mt-3" />

      <div class="flex flex-col gap-2.5 pt-2.5">
        <div class="flex items-center justify-between text-sm/tight text-primary/60">
          <p>{review.name}</p>
          <div class="flex items-center">
            <Icon icon="check-circle" class="w-4 h-4" />
            <p class="text-right">{$t('reviews.verified')}</p>
          </div>
        </div>
      </div>
    {/if}
  </div>
{/if}
